import { InjectionToken, Provider } from "@angular/core";
import { DEFAULT_SORT_DIRECTION_ORDER, SortDirection } from "@shared/components/table-implementation/types/sorting-directions";
import { merge } from "es-toolkit";

export const TABLE_THEME: InjectionToken<TableTheme> = new InjectionToken<TableTheme>("TABLE_THEME");
export interface TableTheme {
  sortDirectionOrder: SortDirection[];
  defaultColumnWidth: number;
}

const DEFAULT_CONFIG: TableTheme = {
  sortDirectionOrder: DEFAULT_SORT_DIRECTION_ORDER,
  defaultColumnWidth: 300
};

export function provideTableTheme (config?: Partial<TableTheme>): Provider[] {
  const mergedConfig: TableTheme = config ? merge(DEFAULT_CONFIG, config) : DEFAULT_CONFIG;

  return [
    {
      provide: TABLE_THEME,
      useValue: mergedConfig
    }
  ] satisfies Provider[];
}
